import { render, staticRenderFns } from "./UsernameAvatar.vue?vue&type=template&id=3efa1852&scoped=true"
import script from "./UsernameAvatar.vue?vue&type=script&lang=js"
export * from "./UsernameAvatar.vue?vue&type=script&lang=js"
import style0 from "./UsernameAvatar.vue?vue&type=style&index=0&id=3efa1852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efa1852",
  null
  
)

export default component.exports